import { useEffect, useRef, useState } from 'react';
import { ColorModel } from '../colorModel';
import type { colorParams, HSVA } from '../types';
import { ColorEnum } from '../types';
import { DEFAULT_BLOCK_BACKGROUND_COLOR } from '../../../documentColorDefaults';

export const useColorManipulate = (color: colorParams, onChange: (color: string) => void) => {
  const [hsva, setHSVA] = useState(ColorModel.toColorSet(color).hsv);

  const cache = useRef({ color, hsva });

  useEffect(() => {
    const hsva = ColorModel.toColorSet(color).hsv;
    if (!ColorModel.isColorEqual(color, cache.current.color)) {
      cache.current = { color, hsva };
      setHSVA(hsva);
    }
  }, [color]);

  useEffect(() => {
    const colors = ColorModel.toColorSet(hsva);
    const colorType = ColorModel.getType(cache.current.color);

    if (
      colorType &&
      !ColorModel.isColorEqual(colors[colorType], cache.current.color) &&
      !ColorModel.isColorEqual(colors.hsv, cache.current.hsva)
    ) {
      cache.current = { color: colors[colorType], hsva };
      onChange(colors[ColorEnum.HEX]);
    }
  }, [hsva, onChange, color]);

  const handleChangeColor = (newHsva: HSVA) => {
    // #ffffff00 is the default transparent background for text blocks. When the user picks a colour
    // set 'a' to 1 (so the colour isn't transparent) and keep 's' value if it was set from Saturation component.
    // else set 's' to 100 (so hue is visible) if saturation was 0 (color was changed from Hue component).
    if (ColorModel.isColorEqual(color, DEFAULT_BLOCK_BACKGROUND_COLOR)) {
      setHSVA({ ...newHsva, s: newHsva.s || 100, a: 1 });
    } else {
      setHSVA(newHsva);
    }
  };

  return { hsva, handleChangeColor };
};
